import { useState } from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { updateMerchantName } from 'api/merchants';

export default function ChangeMerchantNameModal({ isOpen, onClose, merchantId, currentMerchantName }) {
  const [newName, setNewName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [updateOnPaymonade, setUpdateOnPaymonade] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleClose = () => {
    setNewName('');
    setFirstName('');
    setLastName('');
    setUpdateOnPaymonade(false);
    onClose();
  };

  const handleUpdate = async () => {
    if (!newName.trim()) {
      toast({
        title: 'New merchant name is required.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    try {
      setIsLoading(true);
      await updateMerchantName({
        merchantId,
        newName: newName.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        updateOnPaymonade,
      });
      toast({
        title: 'Merchant name updated successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      handleClose();
    } catch (error) {
      toast({
        title: 'Failed to update merchant name.',
        description: error?.response?.data?.message || error?.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Change Merchant Name</ModalHeader>
        <ModalCloseButton />
        <ModalBody px={8}>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Current Name</FormLabel>
              <Input value={currentMerchantName || ''} isDisabled />
            </FormControl>
            <FormControl>
              <FormLabel>New Name</FormLabel>
              <Input
                placeholder='Enter new merchant name'
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>First Name</FormLabel>
              <Input placeholder='Enter first name' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Last Name</FormLabel>
              <Input placeholder='Enter last name' value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </FormControl>
            <Checkbox
              isChecked={updateOnPaymonade}
              onChange={(e) => setUpdateOnPaymonade(e.target.checked)}
              alignSelf='start'
            >
              Update name on Paymonade
            </Checkbox>
          </VStack>
        </ModalBody>
        <ModalFooter px={8}>
          <Button variant='ghost' mr={3} onClick={handleClose}>
            Cancel
          </Button>
          <Button colorScheme='blue' onClick={handleUpdate} isLoading={isLoading} isDisabled={!newName.trim()}>
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
